import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';

import { pushParams } from 'dpl/actions/query_params';
import Button, { BUTTON_VARIANTS } from 'dpl/common/design_system/Button';
import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';
import { JOIN_AS_SHELTER_PATH } from 'dpl/shared/constants/urls';
import SmartImage from 'dpl/components/SmartImage';
import SmartLink from 'dpl/components/SmartLink';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import { ANALYTICS_EVENTS, ANALYTICS_VIEWS } from 'dpl/constants/analytics';

import bluepuppyImage from 'dpl/assets/bluepuppy.png';

const { BREEDER_SIGNUP, SIGNUP } = SIGNUP_FORM_TYPES;

export default function SignupFormIntro() {
  const findADogText = 'Find a dog';
  const joinShelterText = 'Join as a shelter or rescue';
  const joinAsBreederText = 'Join as a breeder';
  useEffect(() => {
    sendAnalyticsEvent(ANALYTICS_EVENTS.REGISTRATION_MODAL_VIEWED, {
      view: ANALYTICS_VIEWS.SIGN_UP_MODAL
    });
  }, []);

  function handleTrackButtonClick({ buttonCta }) {
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      view: ANALYTICS_VIEWS.SIGN_UP_MODAL,
      button_cta: buttonCta
    });
  }

  const dispatch = useDispatch();

  function handleFindADogClick() {
    handleTrackButtonClick({ buttonCta: findADogText });
    dispatch(pushParams({ direct_signup: SIGNUP }, { hash: true }));
  }

  function handleBreederSignupClick() {
    handleTrackButtonClick({ buttonCta: joinAsBreederText });
    dispatch(pushParams({ direct_signup: BREEDER_SIGNUP }, { hash: true }));
  }

  function handleShelterClick() {
    handleTrackButtonClick({ buttonCta: joinShelterText });
  }

  const buttonClass = 'font-16 fw-medium ph12 pv3';
  return (
    <div className="bg-sand br4 pv10 ph0 ph14-lg tc">
      <div className="flex justify-center">
        <div style={{ width: '141px' }}>
          <SmartImage src={bluepuppyImage} />
        </div>
      </div>
      <h1 className="md:font-32 font-28 fw-medium lh-title">
        Welcome to Good Dog!
      </h1>
      <h2 className="font-16 font-sans fw-normal secondary lh-title pt2 pb6">
        What are you looking to do?
      </h2>
      <div style={{ display: 'grid', gap: '8px' }}>
        <Button onClick={handleFindADogClick} className={buttonClass}>
          {findADogText}
        </Button>
        <Button
          data-test-id="breeder_sign_up_button"
          variant="outline"
          onClick={handleBreederSignupClick}
          className={buttonClass}
        >
          {joinAsBreederText}
        </Button>
        <SmartLink
          onClick={handleShelterClick}
          to={JOIN_AS_SHELTER_PATH}
          className={classnames(
            buttonClass,
            BUTTON_VARIANTS.outline,
            'lh-normal'
          )}
        >
          {joinShelterText}
        </SmartLink>
      </div>
    </div>
  );
}
